import script from "./ContactVerificationForm.vue3.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContactVerificationForm.vue3.vue?vue&type=script&setup=true&lang=ts"

import "./ContactVerificationForm.vue3.vue?vue&type=style&index=0&id=218020a0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-218020a0"]])

export default __exports__